
const STICKER_FILES = import.meta.glob('../Assets/Stickers/**/*.png', {
  eager: true,
  query: '?url',
  import: 'default'
}) as Record<string, string>;

const getStickerLabelFromPath = (filePath: string) => {
  const fileName = filePath.split('/').pop() ?? filePath;
  return fileName.replace(/\.(png)$/i, '');
};

const getStickerIdFromLabel = (label: string) => {
  return label
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-_]/g, '');
};

const getStickerSortKey = (label: string) => {
  const match = label.match(/\((\d+)\)$/);
  if (!match) return { kind: 'text' as const, value: label.toLowerCase() };
  return { kind: 'num' as const, value: Number(match[1]) };
};

export const STICKER_ASSETS = Object.entries(STICKER_FILES)
  .map(([filePath, url]) => {
    const label = getStickerLabelFromPath(filePath);
    return {
      id: getStickerIdFromLabel(label),
      url,
      label
    };
  })
  .sort((a, b) => {
    const ka = getStickerSortKey(a.label);
    const kb = getStickerSortKey(b.label);
    if (ka.kind === 'num' && kb.kind === 'num') return ka.value - kb.value;
    if (ka.kind === 'num') return -1;
    if (kb.kind === 'num') return 1;
    return ka.value.localeCompare(kb.value);
  });
